<template>
  <div class="mb-10">
    <TituloPagina :titulo="tituloDaPagina" data-cy="pagina_dados_pessoais" />
    <v-form>
      <p
        class="primary--text mt-5 mb-0"
      >
        Entidade
      </p>

      <v-radio-group
        v-model="form.radios"
        row
        class="mt-5 pt-0 fonte-radio"
        :mandatory="true"
      >
        <v-radio
          label="Pessoa física"
          value="cpf"
          color="grey darken-1"
          class="mr-10"
        />

        <v-radio
          label="Pessoa jurídica"
          value="cnpj"
          color="grey darken-1"
        />
      </v-radio-group>

      <v-text-field
        v-model.trim="form.nomeFavorecido"
        label="Titular da conta bancária"
        filled
        background-color="white"
        data-cy="input_nome_favorecido"
        class="mt-1"
        :error-messages="errorMessagesNome"
        @blur="$v.form.nomeFavorecido.$touch()"
      />

      <v-text-field
        v-model="form.fieldCpfCnpj"
        v-mask="form.radios === 'cpf' ? '###.###.###-##' : '##.###.###/####-##'"
        filled
        required
        data-cy="input_cpf_cnpj"
        background-color="white"
        :label="`${form.radios.toUpperCase()} do titular da conta bancária `"
        :error-messages="errorMessagesCpfCnpj(form.radios)"
        :messages="`Informar o mesmo ${form.radios.toUpperCase()} que está cadastrado no banco.`"
        @blur="$v.form.fieldCpfCnpj.$touch()"
      />
    </v-form>

    <v-btn
      v-if="alterarDadosBancarios"
      block
      outlined
      color="primary"
      class="mt-6"
      data_cy="usar_conta_cadastrada"
      @click="manterDados()"
    >
      Usar conta cadastrada
    </v-btn>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';
import { cpf, cnpj } from 'cpf-cnpj-validator';
import { required } from 'vuelidate/lib/validators';
import { mapGetters, mapActions } from 'vuex';
import TituloPagina from '@/components/TituloPagina.vue';

export default {

  name: 'PassoDadosPessoais',

  components: {
    TituloPagina,
  },

  directives: { mask },

  data() {
    return {
      tituloDaPagina: 'Dados pessoais',
      form: {
        radios: 'cpf',
        nomeFavorecido: '',
        fieldCpfCnpj: '',
      },
      mensagens: {
        nomeFavorecido: 'Preencha o campo corretamente com nome completo.',
      },
    };
  },

  computed: {
    ...mapGetters(['alterarDadosBancarios']),

    errorMessagesNome() {
      if (this.$v.form.nomeFavorecido.$invalid && this.$v.form.nomeFavorecido.$dirty) {
        return this.mensagens.nomeFavorecido;
      }

      return [];
    },
  },

  watch: {
    form: {
      handler() {
        this.validarForm();
      },
      deep: true,
    },
  },

  validations() {
    return {
      form: {
        radios: { required },
        fieldCpfCnpj: {
          required,
          cpfCnpj: value => ((this.form.radios === 'cpf') ? cpf.isValid(value) : cnpj.isValid(value)),
        },
        nomeFavorecido: {
          required,
          possuiSobrenome: value => value.indexOf(' ') !== -1,

        },
      },
    };
  },

  methods: {
    ...mapActions(['setAlterarDadosBancarios']),

    validarForm() {
      this.$emit('formValidado', {
        validado: !this.$v.form.$invalid,
        form: this.form,
      });
    },

    errorMessagesCpfCnpj(tipo) {
      if (this.$v.form.fieldCpfCnpj.$invalid && this.$v.form.fieldCpfCnpj.$dirty) {
        return `Por favor, digite um ${tipo.toUpperCase()} válido.`;
      }

      return [];
    },

    manterDados() {
      this.setAlterarDadosBancarios(false);
      this.$emit('manterDadosBancarios', true);
    },
  },
};
</script>

<style lang="scss">
.fonte-radio label {
  font-size: 13px;
  color: var(--v-primary-base) !important;
}
</style>
